import { Grid, MenuItem, Pagination, Select, Typography, } from "@mui/material";
import React from "react";

export const VWPagination = ({ pageDetails, pageChange, totalRecords = 0, pageSize = 1, setPageSize }) => {
    const { totalPages, currentPage } = pageDetails || {};
    const pageSizeOptions = [
        { label: '10', value: 10 },
        { label: '20', value: 20 },
        { label: '30', value: 30 },
        { label: '40', value: 40 },
        { label: '50', value: 50 },
    ]
    let startIndex = (((currentPage * pageSize) + 1) - pageSize);
    if (totalRecords === 0) {
        startIndex = 0;
    }
    let endIndex = (currentPage * pageSize);
    if (endIndex > totalRecords) {
        endIndex = totalRecords;
    }
    const changePageSize = (e) => {
        const { value } = e.target || {};
        // console.log("value: ", value);
        setPageSize(value)
    }
    return (
        <Grid container alignItems="center" justifyContent="space-between" marginTop={4}>
            <Grid item sx={{ marginLeft: "20px" }}>
                <Typography color="primary" sx={{ fontWeight: "bold" }}>
                    {startIndex} - {endIndex} of {totalRecords}
                </Typography>
            </Grid>
            <Grid item>
                <Grid container alignItems="center">
                    <Grid item sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                        <Typography color="primary" sx={{ fontWeight: "bold" }}>
                            Rows Per Page
                        </Typography>
                        <Select
                            size="small"
                            value={pageSize}
                            onChange={changePageSize}
                        >
                            {pageSizeOptions?.map((size, index) => (
                                <MenuItem value={size?.value} key={index}>{size.label}</MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Pagination
                        count={totalPages}
                        color="secondary"
                        showFirstButton
                        showLastButton
                        page={currentPage}
                        onChange={(e, value) => { pageChange(value) }}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}